'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' });

var CloudUpload = function CloudUpload(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CloudUpload = (0, _pure2.default)(CloudUpload);
CloudUpload.muiName = 'SvgIcon';

exports.default = CloudUpload;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CloudUpload.js
// module id = 2263
// module chunks = 0